export function datesEqual(date1: Date, date2: Date): boolean {
    date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

    return date1.getTime() === date2.getTime();
}

export function getMonth(date: Date): string {
    const months = getMonths();

    return months[date.getMonth()];
}

export function getMonths(): Array<string> {
    return ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
}
